import { AsyncGettersAPI, createAsyncGetters } from '@play-co/replicant';
import { ReplicantFromState, stateSchema } from '../../State';
import ab from '../../ruleset/ab';
import computedProperties from '../computedProperties';

export type AsyncGetterAPI = AsyncGettersAPI<ReplicantFromState<typeof config>>;
export type ElasticSearchQuery = Parameters<AsyncGetterAPI['searchPlayers']>[0];
export type ElasticSearchQueryWhere = ElasticSearchQuery['where'];

// Helper for defining module async getters
const config = {
  ruleset: { abTests: ab.dynamicAB },
  computedProperties,
};
export default createAsyncGetters(stateSchema, config);
